import { useSearchParams } from 'next/navigation';
import React from 'react';

import cn from 'classnames';

import TcIcon from '@/components/Icon/TcIcon';
import UIResourceHtml from '@/components/UIResource/Html';
import { useUIResourcePool } from '@/ducks/common/resources';

import './TravelPartyMultiCabinDes.scss';

export const UI_RESOURCE_POOL = {
  groupBookings: 'PreCheckout.GroupBookings',
  groupBookingsHeading: 'Precheckout.GroupBookings.heading',
  helpAndSupport: 'PreCheckout.HelpAndSupport',
  helpHeading: 'Precheckout.Help.heading',
};

const TravelPartyMultiCabinDesc = () => {
  const { groupBookingsHeading, helpHeading } = useUIResourcePool(UI_RESOURCE_POOL);

  const params = useSearchParams();
  const isCharter = params.get('charterId');

  return (
    <div className="TravelPartyMultiCabinDesc">
      <div className="TravelPartyMultiCabinDesc__detailSection">
        {!isCharter && (
          <>
            <div className="multipleCabin">
              <span className="TcIcon">
                <TcIcon />
              </span>
              <h3>{groupBookingsHeading}</h3>
              <span className="detailSummary">
                <UIResourceHtml id="Precheckout.groupBookings.richText" />
              </span>
            </div>
            <div className="break" />
          </>
        )}
        <div className={cn('description', { wTopPadding: isCharter })}>
          <span className="TcIcon">
            <TcIcon />
          </span>
          <h3 className="descriptionTitle">{helpHeading}</h3>
          <span className="detailSummary">
            <UIResourceHtml id="Precheckout.helpAndSupport.richText" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default TravelPartyMultiCabinDesc;
